<div class="spinner-container">
    <mat-spinner diameter="70" color="accent"></mat-spinner>
</div>
